import React from "react";

export default function Technology(props: any) {
  const { cSM } = props;
  return <div>Technology</div>;
}
